@if (mapOptions) {
  <google-map
    width="100%"
    height="100%"
    [center]="center"
    [zoom]="zoom"
    [options]="mapOptions"
    (centerChanged)="onCenterChange()"
    (zoomChanged)="onZoomChange()"
    (mapClick)="onMapClick($event)"
    (mapInitialized)="onMapInitialized($event)"
  >
    @if (myLocationMarker) {
      <map-marker [options]="myLocationMarker"></map-marker>
    }
    @for (marker of storageLocationMarkers; track marker) {
      <map-marker
        [options]="getMarkerOptions(marker)"
        (mapClick)="onStorageLocationMarkerClick(marker)"
        (mapMouseover)="onStorageLocationMarkerMouseOver(marker)"
        (mapMouseout)="onStorageLocationMarkerMouseOut(marker)"
      >
      </map-marker>
    }
    @for (circle of storageLocationCircles; track circle) {
      <map-circle [options]="circle" />
    }
    @if (enableStorageLocationInfoWindows) {
      <map-info-window [options]="mapInfoWindowOptions">
        @if (openStorageLocation) {
          <a
            [id]="'makeBookingFromMap_' + openStorageLocation._id"
            class="shop-list-item"
            (click)="onStorageLocationClick(openStorageLocation)"
          >
            <lh-simple-shop-item
              [shop]="openStorageLocation"
              [distanceUnit]="distanceUnit | async"
              (bookingRequest)="onBookingRequest(openStorageLocation)"
            ></lh-simple-shop-item>
          </a>
        }
      </map-info-window>
    }
  </google-map>
}
